import { usePDF } from 'react-to-pdf';
import { App, Button, Modal } from 'antd';
import React from 'react'

function PDFListDownloader({ records, columns }) {
    const { modal } = App.useApp();
    const { toPDF, targetRef } = usePDF({ filename: 'weda_arana_data.pdf', page: { orientation: 'landscape' } });

    const openView = () => {
        modal.info({
            width: 'full',
            content: (
                <div>
                    <div className='text-center pt-5'> <Button onClick={() => toPDF()}>Download</Button></div>
                    <div ref={targetRef} className='p-10'>
                        <DynamicTable records={records} columns={columns} />
                    </div>
                </div>
            )
        })
    }
    return (
        <div >
            <Button onClick={openView}>PDF</Button>

        </div>
    )
}

const DynamicTable = ({ records, columns }) => {
    if (!records || !records.length) {
        return <div className="text-center text-gray-500 py-4">No data available</div>;
    }

    return (
        <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300 rounded-md">
                <thead className="bg-gray-100">
                    <tr>
                        {columns.map((col) => (
                            <th
                                key={col.key}
                                className="px-4 py-2 text-left text-sm font-medium text-gray-700 border-b"
                            >
                                {col.label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {records.map((record, rowIndex) => (
                        <tr
                            key={rowIndex}
                            className={`${rowIndex % 2 === 0 ? "bg-white" : "bg-gray-50"
                                } hover:bg-gray-100`}
                        >
                            {columns.map((col) => (
                                <td key={col.key} className="px-4 pb-4 text-sm text-gray-700 border-b">
                                    {record[col.key] || "-"}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default PDFListDownloader